
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.2439 15.5708H4.95445C4.63874 15.5708 4.38281 15.325 4.38281 15.0219C4.38281 14.7187 4.63874 14.4729 4.95445 14.4729H15.2439C15.5596 14.4729 15.8155 14.7187 15.8155 15.0219C15.8155 15.325 15.5596 15.5708 15.2439 15.5708Z","fill":"#00957B"}}),_c('path',{attrs:{"d":"M15.2208 12.4729H6.88451C6.55566 12.4729 6.28906 12.2271 6.28906 11.924C6.28906 11.6208 6.55566 11.375 6.88451 11.375H15.2208C15.5497 11.375 15.8163 11.6208 15.8163 11.924C15.8163 12.2271 15.5497 12.4729 15.2208 12.4729Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.3399 9.375H6.76542C6.50234 9.375 6.28906 9.12924 6.28906 8.82607C6.28906 8.5229 6.50234 8.27714 6.76542 8.27714H15.3399C15.603 8.27714 15.8163 8.5229 15.8163 8.82607C15.8163 9.12924 15.603 9.375 15.3399 9.375Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M15.2439 6.27734H4.95445C4.63874 6.27734 4.38281 6.03158 4.38281 5.72841C4.38281 5.42525 4.63874 5.17948 4.95445 5.17948H15.2439C15.5596 5.17948 15.8155 5.42525 15.8155 5.72841C15.8155 6.03158 15.5596 6.27734 15.2439 6.27734Z","fill":"currentColor"}})])
          )
        }
      }
    